import { Header } from '@/components/Header';
import { CompetitorMediaEffectOnClientRevenueSection } from '@/dashboards/CompetitorsMediaInvestment/CompetitorMediaEffectOnClientRevenueSection';
import { CompetitorMediaEffectSection } from '@/dashboards/CompetitorsMediaInvestment/CompetitorMediaEffectSection';
import { CompetitorMediaInvestmentSection } from '@/dashboards/CompetitorsMediaInvestment/CompetitorMediaInvestmentSection';
import { CompetitorsMediaSeasonalitySection } from '@/dashboards/CompetitorsMediaInvestment/CompetitorsMediaSeasonalitySection';
import { CompetitorsMediaInvestmentProvider } from '@/dashboards/CompetitorsMediaInvestment/providers';
import {
    Can,
    FEATURE_FLAG_ACTIONS,
    FEATURE_FLAG_SUBJECTS,
} from '@/features/Casl';
import { useRef } from 'react';
import { ActionBar } from '@/dashboards/CompetitorsMediaInvestment/components/ActionBar';
import { FullScreenProvider } from '@/components/FullScreen';

export const CompetitorsMediaInvestment = () => {
    const portalRef = useRef<HTMLDivElement>(null);
    return (
        <CompetitorsMediaInvestmentProvider>
            <Header
                className="pb-6 px-8 lg:px-16 pt-6"
                title="Competitor's Media Investment"
                sticky
            >
                <ActionBar />
            </Header>
            <div className="pb-8 px-8 lg:px-16">
                <div className="transition-all duration-300" ref={portalRef} />

                <FullScreenProvider portalRef={portalRef}>
                    <div className="flex flex-row h-full">
                        <div className="flex flex-col 2xl:flex-row gap-4 w-full">
                            <div className="flex flex-col w-6/12 max-2xl:w-full gap-6">
                                <Can
                                    I={FEATURE_FLAG_ACTIONS.VIEW}
                                    a={
                                        FEATURE_FLAG_SUBJECTS.COMPETITORS_MEDIA_DASHBOARD_MEDIA_INVESTMENT_SECTION
                                    }
                                >
                                    <CompetitorMediaInvestmentSection />
                                </Can>
                                <Can
                                    I={FEATURE_FLAG_ACTIONS.VIEW}
                                    a={
                                        FEATURE_FLAG_SUBJECTS.COMPETITORS_MEDIA_DASHBOARD_TOTAL_MEDIA_EFFECT_ON_REVENUE_SECTION
                                    }
                                >
                                    <CompetitorMediaEffectOnClientRevenueSection />
                                </Can>
                            </div>
                            <div className="flex flex-col h-full w-6/12 max-2xl:w-full gap-6">
                                <Can
                                    I={FEATURE_FLAG_ACTIONS.VIEW}
                                    a={
                                        FEATURE_FLAG_SUBJECTS.COMPETITORS_MEDIA_DASHBOARD_MEDIA_SEASONALITY_SECTION
                                    }
                                >
                                    <CompetitorsMediaSeasonalitySection />
                                </Can>
                                <Can
                                    I={FEATURE_FLAG_ACTIONS.VIEW}
                                    a={
                                        FEATURE_FLAG_SUBJECTS.COMPETITORS_MEDIA_DASHBOARD_MEDIA_EFFECT_SECTION
                                    }
                                >
                                    <CompetitorMediaEffectSection />
                                </Can>
                            </div>
                        </div>
                    </div>
                </FullScreenProvider>
            </div>
        </CompetitorsMediaInvestmentProvider>
    );
};
